import { render, staticRenderFns } from "./InspirationContentList.vue?vue&type=template&id=0d82bf3f&"
import script from "./InspirationContentList.vue?vue&type=script&lang=js&"
export * from "./InspirationContentList.vue?vue&type=script&lang=js&"
import style0 from "./InspirationContentList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports